export const MAGIC_LINK_SUPPORT_MESSAGE =
	'Unable to send the sign-in link. Please try again or contact support.'

export const MAGIC_LINK_MISSING_USER_MESSAGE = 'Failed to send email'
